import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../core/portal/loading.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="app-loader" *ngIf="loading.visible()" role="status" aria-live="polite" aria-label="Loading">
      <span class="app-loader__spinner" aria-hidden="true"></span>
    </div>
  `,
  styles: [
    `
      .app-loader {
        position: fixed;
        top: 0.85rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1200;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.96);
        box-shadow: 0 4px 16px rgba(15, 42, 74, 0.12);
        border: 1px solid rgba(13, 110, 106, 0.12);
        pointer-events: none;
      }

      .app-loader__spinner {
        width: 1rem;
        height: 1rem;
        border-radius: 999px;
        border: 2px solid rgba(13, 110, 106, 0.18);
        border-top-color: #0d6e6a;
        animation: app-loader-spin 0.7s linear infinite;
      }

      @keyframes app-loader-spin {
        to {
          transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class LoaderComponent {
  readonly loading = inject(LoadingService);
}
